import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Menu, X } from 'lucide-react';

export const Navbar = ({ scrolled = true, currentPage = '' }) => {
  const [showMenu, setShowMenu] = useState(false);

  const navLinks = [
    { name: 'Beranda', path: '/beranda', id: 'beranda' },
    { name: 'Produk', path: '/produk', id: 'produk' },
    { name: 'Tentang Kami', path: '/tentang', id: 'tentang' },
    { name: 'Kontak', path: '/kontak', id: 'kontak' },
    { name: 'Blog', path: '/blog', id: 'blog' },
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 w-full transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
      data-testid="main-navbar"
    >
      <div className="container mx-auto px-4 py-4 flex justify-between items-center max-w-full">
        <Link 
          to="/beranda" 
          className={`text-xl md:text-2xl font-bold truncate transition-colors duration-300 ${
            scrolled ? 'text-gray-800' : 'text-white'
          }`}
          data-testid="nav-logo"
        >
          Park Serpong
        </Link>
        
        {/* Desktop Navigation */}
        <nav className="hidden lg:flex gap-6 xl:gap-8" data-testid="nav-desktop">
          {navLinks.map((link) => (
            <Link
              key={link.id}
              to={link.path}
              className={`text-sm xl:text-base font-semibold transition-colors whitespace-nowrap ${
                currentPage === link.id
                  ? 'text-blue-600'
                  : scrolled 
                    ? 'text-gray-700 hover:text-blue-600' 
                    : 'text-white hover:text-blue-300'
              }`}
              data-testid={`nav-${link.id}`}
            >
              {link.name}
            </Link>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setShowMenu(!showMenu)}
          className={`lg:hidden p-2 rounded-lg transition-colors ${
            scrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
          }`}
          data-testid="nav-menu-toggle"
        >
          {showMenu ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {showMenu && (
        <div className="lg:hidden bg-white border-t shadow-lg" data-testid="nav-mobile-menu">
          <div className="container mx-auto px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.id}
                to={link.path}
                className={`block py-2 font-semibold ${
                  currentPage === link.id
                    ? 'text-blue-600'
                    : 'text-gray-700 hover:text-blue-600'
                }`}
                onClick={() => setShowMenu(false)}
                data-testid={`nav-mobile-${link.id}`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
